module.exports = __webpack_public_path__ + "static/media/icon_baozhi_grey.89eef90b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/icon_baozhi_grey.png
// module id = 2160
// module chunks = 0